module.exports = __webpack_public_path__ + "./fonts/AvenirNextLTPro-MediumCn.otf";